const state = {
  tankerName: "ALL",
  data: [],
};

const getters = {
  getTankerName(state) {
    return state.tankerName;
  },
};

const actions = {
  setTankerName(context, data) {
    context.commit("SET_TANKER_NAME", data);
  },
  changeTanker(context, data) {
    context.commit("CHANGE_TANKER", data);
  },
};

const mutations = {
  SET_TANKER_NAME(state, data) {
    state.tankerName = data;
  },
  CHANGE_TANKER(state, data) {
    state.tankerData = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
